import styled from 'styled-components';

export const HomeSpecsStyles = styled.div`
  display: flex;

  > div {
    margin-right: 24px;

    .icon {
      margin-right: 6px;
      position: relative;
      top: 2px;
    }
  }
`;
